
import React from "react";
import { Mail, Phone, UserPlus, CheckCircle } from "lucide-react";
import { ProfileAvatar } from "@/components/ui/profile-avatar";
import { UserProfile } from "./types";

interface UserInfoTabProps {
  user: UserProfile;
}

export const UserInfoTab: React.FC<UserInfoTabProps> = ({ user }) => {
  const getRoleBadge = (role: string) => {
    switch (role) {
      case "admin":
        return <span className="inline-block px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm">Admin</span>;
      case "ouvrier":
        return <span className="inline-block px-3 py-1 bg-gray-100 text-gray-800 rounded-full text-sm">Ouvrier</span>;
      default:
        return <span className="inline-block px-3 py-1 bg-gray-100 text-gray-800 rounded-full text-sm">Inconnu</span>;
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-sm p-4">
      <h3 className="text-lg font-bold text-[#333333] mb-4">Informations</h3>
      
      {/* Profile section with avatar */}
      <div className="flex items-center space-x-4 mb-6 pb-4 border-b">
        <ProfileAvatar 
          avatarUrl={null}
          role={user.role}
          size="xl"
        />
        <div>
          <h4 className="text-xl font-bold text-[#333333]">{user.name}</h4>
          {getRoleBadge(user.role)}
        </div>
      </div>
      
      <div className="space-y-4">
        <div className="flex items-center">
          <Mail className="w-6 h-6 text-[#666666]" />
          <span className="ml-2 text-[#666666]">{user.nickname}</span>
        </div>
        
        <div className="flex items-center">
          <Phone className="w-6 h-6 text-[#666666]" />
          <span className="ml-2 text-[#666666]">{user.phone || "Non défini"}</span>
        </div>
        
        <div className="flex items-center">
          <CheckCircle className="w-6 h-6 text-[#666666]" />
          <span className="ml-2 px-3 py-1 bg-green-100 text-green-800 rounded-full text-sm">
            {user.active ? "Actif" : "Inactif"}
          </span>
        </div>
      </div>
    </div>
  );
};
